import React, { useEffect, useState } from 'react';
import api from '../api';
import * as XLSX from 'xlsx';
import '../styles/relatorioStatusCursos.scss';

const RelatorioStatusCursos = () => {
    const [relatorioStatusCursos, setRelatorioStatusCursos] = useState([]);
    const [filteredStatus, setFilteredStatus] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const cursosPorPagina = 10;

    useEffect(() => {
        const fetchRelatorioStatusCursos = async () => {
            try {
                const response = await api.get('/relatorio/cursos');
                const statusCursos = Object.entries(response.data.statusCursos).map(([curso, status]) => ({
                    'CURSO OFERTADO': curso,
                    'ATIVAS': status.ativas,
                    'INATIVAS': status.inativas,
                }));

                setRelatorioStatusCursos(statusCursos);
                setFilteredStatus(statusCursos);
            } catch (error) {
                console.error('Erro ao buscar relatório de status de cursos:', error);
            }
        };

        fetchRelatorioStatusCursos();
    }, []);

    useEffect(() => {
        const results = relatorioStatusCursos.filter(curso =>
            curso['CURSO OFERTADO'].toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredStatus(results);
        setCurrentPage(1);
    }, [searchTerm, relatorioStatusCursos]);

    const downloadExcel = () => {
        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(filteredStatus);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Relatório de Status de Cursos');

        const now = new Date();
        const formattedDate = now.toLocaleString('pt-BR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).replace(/\//g, '-').replace(',', '');

        const fileName = `RelatorioStatusCursos—${formattedDate}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    const indexOfLastStatus = currentPage * cursosPorPagina;
    const indexOfFirstStatus = indexOfLastStatus - cursosPorPagina;
    const currentStatus = filteredStatus.slice(indexOfFirstStatus, indexOfLastStatus);
    const totalPages = Math.ceil(filteredStatus.length / cursosPorPagina);

    const getPaginationButtons = () => {
        const buttons = [];
        buttons.push(1);

        if (currentPage > 3) {
            buttons.push("...");
        }

        for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
            buttons.push(i);
        }

        if (currentPage < totalPages - 2) {
            buttons.push("...");
        }

        if (totalPages > 1) {
            buttons.push(totalPages);
        }

        return buttons;
    };

    return (
        <div>
            <h1>Relatório de Status de Cursos</h1>
            <input
                type="text"
                placeholder="Filtrar por nome do curso"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
            <button className='btn-download-excel' onClick={downloadExcel}>Download Excel</button>
            <table>
                <thead>
                    <tr>
                        <th>Curso Ofertado</th>
                        <th>Ativas</th>
                        <th>Inativas</th>
                    </tr>
                </thead>
                <tbody>
                    {currentStatus.map((curso, index) => (
                        <tr key={index}>
                            <td>{curso['CURSO OFERTADO']}</td>
                            <td>{curso['ATIVAS']}</td>
                            <td>{curso['INATIVAS']}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <div className="pagination">
                {getPaginationButtons().map((page, index) => (
                    <button key={index} onClick={() => {
                        if (page !== "...") {
                            setCurrentPage(page);
                        }
                    }} disabled={page === "..."}>{page}</button>
                ))}
            </div>
        </div>
    );
};

export default RelatorioStatusCursos;
